import axios from 'axios';

export const OKEDService = {
  async getOKED(pagination) {
    const { page, perPage } = pagination;

    const res = await axios.get('activities/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async getAllOKED() {
    const res = await axios.get('activities/all/');

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async createOKED(data) {
    const res = await axios.post('activities/', data);

    if (res.status === 201) {
      return true;
    }
    return Promise.reject();
  },
  async updateOKED(data, id) {
    const res = await axios.put(`activities/${id}/`, data);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async deleteOKED(id) {
    const res = await axios.delete(`activities/${id}/`);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
};
